import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private _snackBar: MatSnackBar) { }

  success(message: string, duration=3000) {
    this._snackBar.open(message, 'Close' , 
      {duration: duration,  panelClass: 'notification-success'});
  }

  info(message: string, duration=3000) {
    this._snackBar.open(message, 'Close' , 
      {duration: duration,  panelClass: 'notification-info'});
  }
  error(message: string, duration=3000) {
    this._snackBar.open(message, 'Close' , 
      {duration: duration,  panelClass: 'notification-error'});
  }
  warning(message: string, duration=3000) {
    this._snackBar.open(message, 'Close' , 
      {duration: duration,  panelClass: 'notification-warning'});
  }
}
